import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('applied_to_1'),
    amountDue: defineMessage('amount_due'),
    currencyName: defineMessage('currency'),
    dateDue: defineMessage('date_due'),
    discountAmount: defineMessage('discount_taken'),
    discountAvailable: defineMessage('discount_available'),
    discountDate: defineMessage('discount_date'),
    originalAmount: defineMessage('original_amount'),
    paymentAmount: defineMessage('payment'),
    reference: defineMessage('reference'),
    type: defineMessage('type_1'),
    billItemText: defineMessage('bill_transactionid'),
};
